/* eslint-disable no-param-reassign,no-unused-vars */
import Vue from 'vue';
import {databaseEnabledPromise} from '@/database';
import dayjs from "dayjs";
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import numeral from 'numeral';

dayjs.extend(quarterOfYear);


const HelperPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $baseUrl() {
          const hasCustomBaseUrl = process.env.VUE_APP_API_BASEURL.indexOf('undefined') === -1;
          if (hasCustomBaseUrl) {
            return process.env.VUE_APP_API_BASEURL;
          }
          return '';
        },
        $years() {
          const max = dayjs().year() + 5
          const min = 2020
          const years = []

          for (let i = max; i >= min; i--) {
            years.push(i)
          }
          return years
        },
        $TEHTAVA_TILA_ALOITTAMATTA() {
          return 'Aloittamatta';
        },
        $TEHTAVA_TILA_KAYNNISSA() {
          return 'Kaynnissa';
        },
        $TEHTAVA_TILA_VALMIS() {
          return 'Valmis';
        },
      },
      methods: {
        $getValmiusprosenttiColor(valmiusprosentti) {
          if (valmiusprosentti < 70 || !valmiusprosentti || isNaN(valmiusprosentti)) {
            return "rgb(255,0,0)";
          }
          if (valmiusprosentti >= 70 && valmiusprosentti < 90) {
            return "rgb(255,191,0)"
          }
          if (valmiusprosentti >= 90) {
            return "rgb(141, 198,63)"
          }
        },
        async $isDbSupported() {
          return await databaseEnabledPromise;
        },
        $reloadApp() {
          location.reload();
        },
        $showErrorNotification(text, useCallback = true, callback, timeout) {
          this.$store.dispatch('showNotification',
            {
              color: 'error',
              message: text,
              timeOut: timeout ? timeout : useCallback ? 10000 : 4000,
              showButton: useCallback,
              buttonText: this.$t('try_again'),
              callback: useCallback ? callback : () => {
              },
            });
        },
        $confirmDelete(message) {
          return this.$root.$confirm(this.$t('delete'), message, {color: 'primary'});
        },
        $showWarningNotification(text, useCallback = true, callback) {
          this.$store.dispatch('showNotification', {
            color: 'warning',
            message: text,
            timeOut: useCallback ? 10000 : 4000,
            showButton: useCallback,
            buttonText: this.$t('try_again'),
            callback: useCallback ? callback : () => {
            },
          });
        },
        $showSuccessNotification(text, useCallback = true, callback) {
          this.$store.dispatch('showNotification', {
            color: 'success',
            message: text,
            timeOut: useCallback ? 10000 : 4000,
            showButton: useCallback,
            buttonText: this.$t('try_again'),
            callback: useCallback ? callback : () => {
            },
          });
        },
        $capitalize(s) {
          return s[0].toUpperCase() + s.substring(1);
        },

        async $fileToBase64(/* File */file) {
          console.log(file);
          if (!(file instanceof File)) return file;

          return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
              resolve(reader.result);
            };
            reader.onerror = function (error) {
              console.error('Error: ', error);
              reject(error)
            };

          })
        },
        $round(number, decimals = 2) {
          if (isNaN(number)) return null;
          if (typeof number === 'number') {
            return parseFloat(number.toFixed(decimals));
          }
          return null;
        },
        $formatPisteet(number) {
          return numeral(number).format('0[.]0')
        },
        $uuid() {
          return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
          );
        }
      },


    });
  },
};

export default HelperPlugin;
